var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4661_13787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 48H6C2.688 48 0 45.312 0 42V6C0 2.688 2.688 0 6 0H42C45.312 0 48 2.688 48 6V42C48 45.312 45.312 48 42 48Z",
    fill: "#1D9BF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4356 36.1926C29.7516 36.1926 35.9436 26.8086 35.9436 18.6846C35.9436 18.4206 35.9436 18.1566 35.9316 17.8926C37.1316 17.0286 38.1756 15.9366 39.0036 14.7006C37.8996 15.1926 36.7116 15.5166 35.4636 15.6726C36.7356 14.9166 37.7076 13.7046 38.1756 12.2646C36.9876 12.9726 35.6676 13.4766 34.2636 13.7526C33.1356 12.5526 31.5396 11.8086 29.7756 11.8086C26.3796 11.8086 23.6196 14.5686 23.6196 17.9646C23.6196 18.4446 23.6796 18.9126 23.7756 19.3686C18.6636 19.1166 14.1276 16.6566 11.0916 12.9366C10.5636 13.8486 10.2636 14.9046 10.2636 16.0326C10.2636 18.1686 11.3556 20.0526 12.9996 21.1566C11.9916 21.1206 11.0436 20.8446 10.2156 20.3886C10.2156 20.4126 10.2156 20.4366 10.2156 20.4726C10.2156 23.4486 12.3396 25.9446 15.1476 26.5086C14.6316 26.6526 14.0916 26.7246 13.5276 26.7246C13.1316 26.7246 12.7476 26.6886 12.3756 26.6166C13.1556 29.0646 15.4356 30.8406 18.1236 30.8886C16.0116 32.5446 13.3596 33.5286 10.4796 33.5286C9.98763 33.5286 9.49562 33.5046 9.01562 33.4446C11.7276 35.1726 14.9676 36.1926 18.4356 36.1926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4661_13787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.6d2db11e2a15638364033fed78e0db97.svg";
export { ForwardRef as ReactComponent };